import ImpactCategoryDialog from "./ImpactCategoryDialog";
export default ImpactCategoryDialog;
